import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProfileState } from '../../../source/appstates/playerstates/playerState';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CashierState } from '../../../source/appstates/cashierstates/cashierState';
import { LoginState } from '../../../source/appstates/loginstates/loginState';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { PlayerService } from '../../../source/services/player/player.service';
import { PlayerGetProfile } from '../../../source/appstates/playerstates/playerActions';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { CashOutInfo } from '../../../source/modules/cashier/withDraw';
import { WithDrawsResponses } from '../../../source/modules/cashier/withdrawResponse';
import { Balance, WalletInfo } from '../../../source/modules/cashier/balance';
import { Profile } from '../../../source/modules/player/profile';
import { CommonModule } from '@angular/common';
import * as playerActions from '../../../source/appstates/playerstates/playerActions'
import * as cashierActions from '../../../source/appstates/cashierstates/cashierActions'
import * as appState from '../../../source/appstates/appState'
import { SlotsService } from '../../../source/services/slotsservice/slots.service';
import { CashierService } from '../../../source/services/cashier/cashier.service';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-withdraw',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink, TranslateModule, FormsModule],
  templateUrl: './withdraw.component.html',
  styleUrl: './withdraw.component.css'
})
export class WithdrawComponent implements OnInit, OnDestroy {
  private storeSub!: Subscription;
  private profilestoreSub!: Subscription;
  profile!: Profile;
  cashier!: Balance;
  cashoutInfo!: CashOutInfo;
  smallLoader: boolean = false;
  paymentMethod: any = 328;
  criptoWithDrawalForm!: FormGroup;
  hideDeposit: boolean = true;
  // hideDeposit: boolean = false;
  isSpinner: boolean = false;
  sessionExpiresuccessPop: boolean = false;
  gifTimestamp = Date.now();
  interFalseRes: any;
  paykassmaFailRes: boolean = false;
  errorResp: boolean = false;
  playerName: string = "";
  loginSub: Subscription;
  playerLoggedIn: boolean = false;
  showMessage: string = "";
  selectedCurrency: any;
  currencyInfo: any;
  currencies: any;
  cryptosymbols: any;
  selectedSymbol: any
  payMethod: any = "coinPayments";
  withdrawPaynetworks: any = [
    'TRC_20',
    'BTC',
    'ETH',
    'ERC_20',
    'TRX',
    'SOL'
  ];
  selectedRate: any = 'Nagad'
  selectedNetwork: any;
  withdrawloader:boolean = false;
  constructor(private store: Store<appState.AppState>, private translate: TranslateService,
    private router: Router, private cashierS: CashierService, private playerSer: PlayerService,
    private playerSers: SlotsService, private meta: Meta, private title: Title, private route: ActivatedRoute) {
    this.store.dispatch(new playerActions.PlayerGetProfile());
    this.store.dispatch(new PlayerGetProfile());
    this.loginSub = this.store
      .select("loginState")
      .subscribe((loginState: LoginState) => {
        if (loginState.playerLoggedIn) {
          this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
        }
        if (!this.playerLoggedIn) {
          this.router.navigate(["/home"]);
        }
      });
  }
  ngOnInit() {
    window.scroll(0, 0);
    let profile = sessionStorage.getItem('profile')
    this.playerSers.paymentMethi(profile).subscribe((data: any) => this.confopaments(data))
    this.storeSub = this.store.select("playerState").subscribe(
      (playerState: ProfileState) => {
        if (playerState.profile) {
          if (playerState.profile.success == true) {
            this.profile = playerState.profile;
            this.playerName = (this.profile.login)
          }
        }
      }
    )
    this.criptoWithDrawalForm = new FormGroup({
      "amount": new FormControl(null, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.min(1000), Validators.max(50000)]),
      "personalNumber": new FormControl(null, [Validators.required, Validators.pattern('^[0-9]*$')],),
      "name": new FormControl(null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 ]*$')
      ]),
      'accountType': new FormControl(this.selectedRate, [Validators.required])
    })

    this.profilestoreSub = this.store.select("playerState").subscribe(
      (playerState: ProfileState) => {
        if (playerState.profile) {
          this.profile = playerState.profile;
        }
      }
    )
    this.storeSub = this.store.select("cashierState").subscribe(
      (cashierState: CashierState) => {
        if (cashierState.withDrawSystem) {
          this.cashoutInfo = cashierState.withDrawSystem.cashOutInfo;
        }
      }
    )
    this.store.dispatch(new cashierActions.CashierGetWithdrawSystems({ id: null }));
    this.translate.get('WITHDRAW_TITLE').subscribe(res => {
      this.title.setTitle(res);
      this.meta.updateTag({ property: 'og:title', content: res });
    });

    this.translate.get('WITHDRAW_DESCRIPTION').subscribe(res => {
      this.meta.updateTag({ name: 'description', content: res });
      this.meta.updateTag({ property: 'og:description', content: res });
    });


    const url = 'https://gambaji.com' + this.router.url;
    this.meta.updateTag({ property: 'og:url', content: url });
  }
 
  onCurrencyChange() {
    this.smallLoader = true;
    this.gifTimestamp = Date.now(); // forces reload of GIF  
    this.playerSers.getCurrencyInfo(this.selectedCurrency).subscribe((data: any) => {
      if (Array.isArray(data)) {
        this.smallLoader = false;
        this.cryptosymbols = data.map(token => token.symbol);
        this.selectedSymbol = this.cryptosymbols[0]
      }
    });

  }
  closePaykassResPopfalse() {
    this.paykassmaFailRes = false
  }
  ngOnDestroy() {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
  }
  confopaments(data: any) {
    if (data.description == "Rohith") {
      this.hideDeposit = false
      this.sessionExpiresuccessPop = true
    } else {
      this.hideDeposit = true
      this.isSpinner = false;
    }
  }
  sessionExpiresuccessPopClose() {
    this.sessionExpiresuccessPop = false
    this.router.navigate(["/home"]);
  }
  payMethodChange(method: any) {
    this.payMethod = method; ``
    this.errorResp = false;
    this.criptoWithDrawalForm.reset()
    this.criptoWithDrawalForm.patchValue({
      networksType: "TRC_20"
    }) 
  }

  onWithdrawSubmit() {
    let body: any;
    this.errorResp = false;
    body = {
      "amount": this.criptoWithDrawalForm.value.amount,
      "paymentMethod": "345",
      "accountType": this.selectedRate,
      "bankName": this.selectedRate,
      "personalNumber": this.criptoWithDrawalForm.value.personalNumber,
      "nameOnAccount": this.criptoWithDrawalForm.value.name,
      // "ifsc": this.selectedRate
    }
    this.withdrawloader = true 
    this.playerSer.interKassaWithDra(body).subscribe((data: any) => {
      console.log(data);
      this.withdrawloader = false
      // const { success, id, errorMsg } = data.result;
      if (data.success && data.result.success) {
        this.showMessage = "WITHDRAWAL_PROCESS_TIME";
        this.paykassmaFailRes = true;
        this.criptoWithDrawalForm.reset();
        this.selectedRate = 'easypaisa'
        this.criptoWithDrawalForm.patchValue({
          networksType: "TRC_20"
        })
      } else if (data?.code === "error" && !data.success) {
        // this.showMessage = "2x wager limit is not met";
        this.showMessage = "2X wager limit not met";
        this.errorResp = true;
        setTimeout(() => {
          this.errorResp = false;
        }, 5000);
      } else {
        this.interFalseRes = data.description ? data.description : data.result.comments ? data.result.comments : data.result.errorMsg;
      }
      setTimeout(() => {
        this.interFalseRes = '';
      }, 3000)
    })
  }
  phonenum(event: any) {
    var k;
    k = event.charCode;
    return (k >= 48 && k <= 57);
  }
  selectedNetworkchange(event: any) {
    console.log(event.target.value)
    console.log(this.selectedNetwork)
    console.log(this.criptoWithDrawalForm.value.networksType)

  }
  Accontnumber(event: any) {
    var k;
    k = event.charCode;
    return (k >= 48 && k <= 57);
  }
  accountName(event: any) {
    var k = event.charCode;
    return (
      (k >= 65 && k <= 90) ||   // A–Z
      (k >= 97 && k <= 122) ||  // a–z
      k === 32                  // space
    );
  }


   goDeposit() {
    this.router.navigate([], {
      queryParams: { modal: 'deposit' },
      queryParamsHandling: 'merge'
    });
  }
}

